export default function Skeleton() {

    return (
        <>
                <div role="status" className="p-4 border border-skeleton rounded-lg shadow animate-pulse md:p-6">
                    <div className="skeleton-color h-2.5 rounded-lg-full 0 w-48 mb-4"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0"></div>
                    <div className="flex items-center mt-4">
                        <div>
                            <div className="skeleton-color h-2.5 rounded-lg-full 0 w-32 mb-2"></div>
                            <div className="skeleton-color w-48 h-2 rounded-lg-full 0"></div>
                        </div>
                    </div>
                    <span className="sr-only skeleton-color">Chargement...</span>
                </div>

                <div role="status" className="p-4 border border-skeleton rounded-lg shadow animate-pulse md:p-6">
                    <div className="skeleton-color h-2.5 rounded-lg-full 0 w-48 mb-4"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0"></div>
                    <div className="flex items-center mt-4">
                        <div>
                            <div className="skeleton-color h-2.5 rounded-lg-full 0 w-32 mb-2"></div>
                            <div className="skeleton-color w-48 h-2 rounded-lg-full 0"></div>
                        </div>
                    </div>
                    <span className="sr-only skeleton-color">Chargement...</span>
                </div>

                <div role="status" className="p-4 border border-skeleton rounded-lg shadow animate-pulse md:p-6">
                    <div className="skeleton-color h-2.5 rounded-lg-full 0 w-48 mb-4"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0 mb-2.5"></div>
                    <div className="skeleton-color h-2 rounded-lg-full 0"></div>
                    <div className="flex items-center mt-4">
                        <div>
                            <div className="skeleton-color h-2.5 rounded-lg-full 0 w-32 mb-2"></div>
                            <div className="skeleton-color w-48 h-2 rounded-lg-full 0"></div>
                        </div>
                    </div>
                    <span className="sr-only skeleton-color">Chargement...</span>
                </div>
        </>
    )
}